<template>
  <!-- Gedeelde header voor de landingspagina en de info-content pagina's. -->
  <header
    class="sticky top-0 z-40 border-b border-[var(--color-mode-border)] bg-[var(--main-background)]/85 backdrop-blur-md"
  >
    <div class="mx-auto max-w-6xl px-5 md:px-8">
      <div class="flex h-16 items-center justify-between gap-6">
        <NuxtLink
          to="/"
          class="flex items-center gap-2 text-xl font-semibold"
        >
          CAOBOT<span class="text-[#7e57c2]">.</span>
        </NuxtLink>

        <nav class="flex items-center gap-2 md:gap-6">
          <NuxtLink
            to="/info#hoe-werkt-het"
            class="hidden text-sm text-neutral-500 transition hover:text-[var(--color-mode-text)] md:inline"
          >
            Hoe werkt het
          </NuxtLink>
          <NuxtLink
            to="/info#waarom"
            class="hidden text-sm text-neutral-500 transition hover:text-[var(--color-mode-text)] md:inline"
          >
            Waarom CAOBOT
          </NuxtLink>
          <NuxtLink
            to="/info/faq"
            class="hidden text-sm text-neutral-500 transition hover:text-[var(--color-mode-text)] md:inline"
          >
            FAQ
          </NuxtLink>
          <NuxtLink
            to="/login"
            class="hidden text-sm text-neutral-500 transition hover:text-[var(--color-mode-text)] md:inline"
          >
            Inloggen
          </NuxtLink>
          <NuxtLink
            to="/register"
            class="rounded-full bg-[var(--btn-primary-bg)] px-4 py-2 text-sm font-medium text-[var(--btn-primary-text)] transition hover:-translate-y-0.5"
          >
            Probeer gratis
          </NuxtLink>
          <UiColorMode />
        </nav>
      </div>
    </div>
  </header>
</template>
